import {
    VALIDATE_STUDENT_REQUEST,
    VALIDATE_STUDENT_SUCCESS,
    VALIDATE_STUDENT_FAILURE,
    CREATE_STUDENT_REQUEST,
    CREATE_STUDENT_SUCCESS,
    CREATE_STUDENT_FAILURE,
  } from '../constants/actionTypes'
  import { fetchRequestWithHeader } from '../utils/fetchRequest'
  import { serviceEndPoint } from '../utils/serviceEndPoint'
 // import { user } from '../utils/fetchCustomerAPI'
  
  export const getEngagementId = async (dispatch, jwtToken, userData) => {
    dispatch({ type: VALIDATE_STUDENT_REQUEST })
    let requestFormData = new FormData()
    requestFormData.append(
      'data',
      '{"token" : "", "action" : "searchByDobAndPrimaryContactNumber", "data" :[{"dob":"' +
        userData?.dob +
        '", "primaryContactNumber":"' +
        userData?.mobileNumber +
        '"}]}'
    )
    return fetchRequestWithHeader(
      serviceEndPoint.studentServiceEndPoint,
      requestFormData,
      jwtToken.token
    )
      .then((response) => {
        dispatch({ type: VALIDATE_STUDENT_SUCCESS, response })
        return response.data
      })
      .catch(() => Promise.reject(dispatch({ type: VALIDATE_STUDENT_FAILURE })))
  }
  
  export const createStudent = async (
    dispatch,
    jwtToken,
    student,
    districtValue
  ) => {
    dispatch({ type: CREATE_STUDENT_REQUEST })
    let requestFormData = new FormData()
    const language = student?.language
    /* call to fetch dbUserId on saving the new student user */
    //   requestFormData.append(
    //     'data',
    //     '{"token" : " ", "action" : "captureBeneficiaryDetails", "data" : [{"gender":"' +
    //       student?.gender +
    //       '","firstName":"' +
    //       student?.firstName +
    //       '","lastName":"' +
    //       student?.lastName +
    //       '","highestQualification":"' +
    //       student?.highestQualification +
    //       '","primaryContactNumber":' +
    //       student?.mobileNumber +
    //       ',"primaryEmailId":"' +
    //       student?.mailId +
    //       '","dob":"' +
    //       student?.dob +
    //       '", "creationChannel":"SR-HR-Samagra"}]}',
    //   )
    requestFormData.append(
      'data',
      '{"token" : " ", "action" : "captureBeneficiaryDetails", "data" : [{"gender":"' +
        student?.gender +
        '","firstName":"' +
        student?.firstName +
        '","lastName":"' +
        student?.lastName +
        '","highestQualification":"' +
        student?.highestQualification +
        '","primaryContactNumber":' +
        student?.mobileNumber +
        ',"primaryEmailId":"' +
        student?.mailId +
        '","dob":"' +
        student?.dob +
        '", "creationChannel":"SR-STRIVE"}]}'
    )
    return fetchRequestWithHeader(
      serviceEndPoint.studentServiceEndPoint,
      requestFormData,
      jwtToken.token
    )
      .then((response) => {
        // console.log(student)
        if (response.status === 'success') {
          let jsonData = JSON.parse(response.data)[0]
          const { dbUserId } = jsonData
          requestFormData = new FormData()
          /* request generated engagementId for the new student user */
                requestFormData.append(
            'data',
            '{"token" : "", "action" : "captureStudentEngagement", "data" :[{"dbUserId"  : ' +
              dbUserId +
              ' , "centerId" : "3049", "createdBy" : "1234","nearestCenter": "' +
              student?.nearestCenter +
              '","interestedCourse": "' +
              student?.interestedCourse +
              '", "remarks" : "","status" : "mobilised"}]}'
          )


          fetchRequestWithHeader(
            serviceEndPoint.engagementServiceEndPoint,
            requestFormData,
            jwtToken.token
          ).then((engagementServiceResponse) => {
            if (engagementServiceResponse.status === 'success') {
              const engagementServiceResponseData = JSON.parse(
                engagementServiceResponse.data
              )[0]
              const { engagementId } = engagementServiceResponseData
              jsonData = { ...jsonData, engagementId, language }
              const data = JSON.stringify(jsonData)
              response = { ...response, data }
              requestFormData = new FormData()
              /* call to save address for the given pincode */
              requestFormData.append(
                'data',
                '{"token" : "", "action" : "captureAddress", "data" :[{"createdBy" :"1234", "isActive":"Y", "type":"R", "pincode": ' +
                  student?.pincode +
                  ', "addressLine1": "' +
                  student?.address +
                  '","addressLine2":"", "district":"' +
                  student.district +
                  // districtValue +
                  // '","state":"Haryana","cityName":"Haryana","villageName":"' +
                  '","villageName": "' +
                  student?.village +
                  '","state": "' +
                  student?.stateName +
                  '","cityName":"' +
                  student?.cityName +
                  '","villageName":"' +
                  student?.village +
                  '","entityId":' +
                  dbUserId +
                  ',"entityType":"S"}]}'
              )
              fetchRequestWithHeader(
                serviceEndPoint.addressServiceEndPoint,
                requestFormData,
                jwtToken.token
              ).then((pincodeServiceResponse) => {
                pincodeServiceResponse.status === 'success'
                  ? dispatch({ type: CREATE_STUDENT_SUCCESS, response })
                  : dispatch({ type: CREATE_STUDENT_FAILURE })
              })
            } else dispatch({ type: CREATE_STUDENT_FAILURE })
          })
        } else {
          dispatch({ type: CREATE_STUDENT_FAILURE })
        }
      })
      .catch(() => Promise.reject(dispatch({ type: CREATE_STUDENT_FAILURE })))
  }